import { render, staticRenderFns } from "./PersonalInformationIframe.vue?vue&type=template&id=bfb99d08&"
import script from "./PersonalInformationIframe.vue?vue&type=script&lang=ts&"
export * from "./PersonalInformationIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports